/**
 * Centralized report/search type identifiers.
 * These discriminator values are used across the application
 * (saved searches, schedulers, saved search fetch/update/delete calls)
 * to identify the source report or search a request belongs to.
 * @flow
 */

const reportTypes = {
  POSEARCH: 'POSEARCH',
  PPM_REPORT: 'PPMREPORT',
  COLLAB_REPORT: 'COLLABREPORT',
  CHANGE_REPORT: 'CHANGEREPORT',
  ITEM_SUMMARY_REPORT: 'ITEMSUMMARYREPORT',
  CONVERSATION_REPORT: 'CONVERSATIONREPORT',
  AIR_FREIGHT_REPORT: 'AIRFREIGHTREPORT',
  GAC_CHANGE_HISTORY_REPORT: 'GACCHANGEHISTORYREPORT'
};

export default reportTypes;
